import { useTranslation } from 'react-i18next';
import { Col } from '../col';
import { Progress, type ProgressProperties, useGetProgressPercent } from '../progress';
import { Row } from '../row';
import { Text, type TextProperties } from '../typography';

export type ProgressIndicatorProperties = {
  progressProperties?: ProgressProperties;
  step: number;
  textProperties?: TextProperties;
  total: number;
};

const ProgressIndicator = ({ progressProperties, step, textProperties, total }: ProgressIndicatorProperties) => {
  const { t } = useTranslation(['translationReactComponents']);
  const getProgressPercent = useGetProgressPercent();

  return (
    <Row gutter={['ms', 0]}>
      <Col>
        <Text weight="bold" {...textProperties}>
          {t('Step {{step}} of {{total}}', { step, total })}
        </Text>
      </Col>
      <Col alignItems="center" flex="1">
        <Progress
          color="success"
          percent={getProgressPercent({ max: total, value: step })}
          showInfo={false}
          {...progressProperties}
        />
      </Col>
    </Row>
  );
};

export default ProgressIndicator;
